import { getOsDockSafeAreaBottomPx } from "@/components/ui/os-layout/osDockSafeArea";
import type { OpenWindowConfig } from "@/components/ui/os-layout/useWindow";

export const GUARDIANS_CONVERSATION_WINDOW_WIDTH = 480;
const GUARDIANS_CONVERSATION_MIN_HEIGHT = 480;

export interface OpenGuardiansConversationInput {
  missionId?: string | null;
  taskId?: string | null;
  title?: string;
  focus?: string | null;
}

/** Size the conversation utility window to 80% of the available desktop height. */
export function getGuardiansConversationWindowSize(): { width: number; height: number } {
  const desktopElement = document.getElementById("main-content");
  const rootFs = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const dockBottomPx = getOsDockSafeAreaBottomPx(Number.isFinite(rootFs) ? rootFs : 16, {
    reserveDockSpace: true,
  });
  const rawHeight = desktopElement?.clientHeight ?? window.innerHeight;
  const desktopHeight = Math.max(0, rawHeight - dockBottomPx);

  return {
    width: GUARDIANS_CONVERSATION_WINDOW_WIDTH,
    height: Math.max(
      GUARDIANS_CONVERSATION_MIN_HEIGHT,
      Math.round(desktopHeight * 0.8),
    ),
  };
}

export function guardiansConversationWindowConfig(
  input: OpenGuardiansConversationInput
): OpenWindowConfig {
  const params: Record<string, string> = {};
  if (input.missionId) params.mission = input.missionId;
  if (input.taskId) params.task = input.taskId;
  if (input.focus) params.focus = input.focus;

  return {
    appId: "ops-guardians-conversation",
    title: input.title ?? "Conversation",
    params,
    initialSize: getGuardiansConversationWindowSize(),
  };
}

export function openGuardiansConversation(
  input: OpenGuardiansConversationInput,
  openWindow: ((config: OpenWindowConfig) => void) | null
): boolean {
  if (!openWindow) return false;
  openWindow(guardiansConversationWindowConfig(input));
  return true;
}
